import { render, staticRenderFns } from "./RadialMenu.vue?vue&type=template&id=48ba1566&scoped=true"
import script from "./RadialMenu.vue?vue&type=script&lang=js"
export * from "./RadialMenu.vue?vue&type=script&lang=js"
import style0 from "./RadialMenu.vue?vue&type=style&index=0&id=48ba1566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba1566",
  null
  
)

export default component.exports